import { render } from "./ConfigurationPractitioners.vue?vue&type=template&id=b7f0a9f4&scoped=true"
import script from "./ConfigurationPractitioners.vue?vue&type=script&lang=js"
export * from "./ConfigurationPractitioners.vue?vue&type=script&lang=js"

import "./ConfigurationPractitioners.vue?vue&type=style&index=0&id=b7f0a9f4&scoped=true&lang=scss"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7f0a9f4"]])

export default __exports__